module.exports = __webpack_public_path__ + "static/media/girl-6.27132fae.svg";